import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { AlertTriangle } from "lucide-react";

interface BlankResponseWarningDialogProps {
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  questionType: string;
}

const getWarningMessage = (questionType: string) => {
  switch (questionType) {
    case 'video_response':
      return "You haven't recorded a video response";
    case 'audio_response':
      return "You haven't recorded an audio response";
    case 'essay':
      return "You haven't typed an answer";
    case 'multiple_choice':
      return "You haven't selected an option";
    case 'coding':
      return "You haven't written any code";
    default:
      return "You haven't provided an answer";
  }
};

export function BlankResponseWarningDialog({
  open,
  onConfirm,
  onCancel,
  questionType,
}: BlankResponseWarningDialogProps) {
  return (
    <AlertDialog open={open} onOpenChange={(isOpen) => !isOpen && onCancel()}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <div className="flex items-center gap-3 mb-2">
            <div className="flex h-10 w-10 items-center justify-center rounded-full bg-yellow-100">
              <AlertTriangle className="h-5 w-5 text-yellow-600" />
            </div>
            <AlertDialogTitle>Submit Blank Response?</AlertDialogTitle>
          </div>
          <AlertDialogDescription className="space-y-2">
            <p className="font-medium text-foreground">
              {getWarningMessage(questionType)}
            </p>
            <p>
              You're about to submit a blank response for this question. Your answer cannot be changed after moving forward.
            </p>
            <p className="text-sm text-muted-foreground">
              We encourage you to provide an answer, even a partial one, as it may contribute to your overall score.
            </p>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={onCancel}>Go Back</AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm} className="bg-destructive hover:bg-destructive/90">
            Submit Anyway
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
